import { ROUTE_PATTERNS } from '@/shared/config/routes';
import { StaggerItem } from '@/shared/ui/animations';

import { AnalysisSectionLayout, SectionBlocks } from '../../components';
import {
  useAnalysisFromContext,
  type AnalysisSectionProps,
} from '../../utils/useAnalysisFromContext';
import { hasContent } from '../../utils/hasContent';
import type { BusinessOpportunity } from './BusinessOpportunities.types';
import { OpportunityPathway } from './components';
import { useTranslation } from 'react-i18next';

export const BusinessOpportunities = ({
  analysis: analysisProp,
  exporting,
}: AnalysisSectionProps = {}) => {
  const { t } = useTranslation('analysis');
  const title = t('analysisResult.businessOpportunities.businessOpportunities');
  const analysis = useAnalysisFromContext(analysisProp);
  const opportunities =
    (analysis.structuredData?.businessOpportunities as BusinessOpportunity[] | undefined) ?? [];

  return (
    <AnalysisSectionLayout
      analysisId={analysis.id}
      brand={analysis.brandName}
      section={ROUTE_PATTERNS.IQ_SECTION_BUSINESS_OPPORTUNITIES}
      title={title}
      subtitle={t('analysisResult.businessOpportunities.growthInnovationPathways', {
        brandName: analysis.brandName,
      })}
      exporting={exporting}
    >
      <SectionBlocks
        category={title}
        blocks={[
          {
            key: 'opportunities',
            hasData: hasContent(opportunities),
            node: (
              // The cards carry their own borders, so the gap alone separates them.
              <div className="flex w-full flex-col gap-8">
                {opportunities.map((opportunity, index) => (
                  <StaggerItem key={opportunity.title ?? index} index={index} variant="swipeUp">
                    <OpportunityPathway
                      opportunity={opportunity}
                      index={index + 1}
                      total={opportunities.length}
                    />
                  </StaggerItem>
                ))}
              </div>
            ),
          },
        ]}
      />
    </AnalysisSectionLayout>
  );
};
